import src from "IMAGE";
export default { src, width: 120, height: 120, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAAAAADhZOFXAAAAPUlEQVR42i3KMQ7AIAwEQf//hdbRBJxUQQIJzjXCsNUUK3oTVZSCQCYtYO5f4JnM52k9bcDGeJMKfrqzYgHPUDgsQn1nyAAAAABJRU5ErkJggg=="};
